export default __webpack_public_path__ + "static/media/rate.02e40ad5.gif";